import { combineReducers } from 'redux';
import deviceReducer from './deviceReducer';
import configReducer from './configReducer';
import baseReducer from './baseReducer';
import filterReducer from './filterReducer';
import ticketINCReducer from './ticketINCReducer';
import ticketRITMReducer from './ticketRITMReducer';
import ticketDetailReducer from './ticketDetailReducer';
import knowledgeDetailReducer from './knowledgeDetailReducer';
import articleReducer from './articleReducer';
import knowledgeReducer from './knowledgeReducer';
import supportSearchReducer from './supportSearchReducer';
import shippingAddressReducer from './shippingAddressReducer';
import ticketApprovalReducer from './ticketApprovalReducer';
import userPreferencesReducer from './userPreferencesReducer';
import onBehalfReducer from './onBehalfReducer';
import ticketActivitiesReducer from './ticketActivitiesReducer';
import notificationReducer from './notificationReducer';
import marketplaceReducer from './marketplaceReducer';
import serviceRequestReducer from './serviceRequestReducer';
import pclReducer from './pclReducer';

const rootReducer = createReducer();

// const rootReducer = combineReducers({
//   deviceReducer,
//   configReducer,
//   baseReducer,
//   filterReducer,
//   ticketINCReducer,
//   ticketRITMReducer,
//   ticketDetailReducer,
//   knowledgeDetail: knowledgeDetailReducer,
//   articleReducer,
//   knowledgeReducer,
//   supportSearchReducer,
//   shippingAddressReducer,
//   ticketApprovalReducer,
//   userPreferencesReducer,
//   onBehalfReducer,
//   ticketActivitiesReducer,
//   notificationReducer,
//   marketplaceReducer,
//   serviceRequestReducer,
// });

export function createReducer(customerReducer = {}) {
  return combineReducers({
    deviceReducer,
    configReducer,
    baseReducer,
    filterReducer,
    ticketINCReducer,
    ticketRITMReducer,
    ticketDetailReducer,
    knowledgeDetail: knowledgeDetailReducer,
    articleReducer,
    knowledgeReducer,
    supportSearchReducer,
    shippingAddressReducer,
    ticketApprovalReducer,
    userPreferencesReducer,
    onBehalfReducer,
    ticketActivitiesReducer,
    notificationReducer,
    marketplaceReducer,
    serviceRequestReducer,
    pclReducer,
    ...customerReducer,
  });
}

export default rootReducer;

export const ReducersProvider = {};
